import type { SVGProps } from 'react';

export const ChevronForward = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.95 12 8.875 7.925a.774.774 0 0 1-.225-.5c0-.217.075-.4.225-.55A.72.72 0 0 1 9.4 6.65c.2 0 .375.075.525.225l4.5 4.5a.681.681 0 0 1 .175.3c.05.1.075.208.075.325a.882.882 0 0 1-.075.35.701.701 0 0 1-.175.275l-4.5 4.5a.802.802 0 0 1-.525.225.72.72 0 0 1-.525-.225.72.72 0 0 1-.225-.525c0-.2.075-.375.225-.525L12.95 12Z" />
    </svg>
  );
};
